<template>
  <div>
    <div
      v-for="subject of listData"
      :key="subject.id"
      :class="[
        type === 'MULTI'
          ? ''
          : isIdpService
          ? 'category-align-item'
          : 'category-nav-item',
        parentClassList,
      ]"
      @click.prevent="subjectList(subject.id, subject.name)"
      @keypress.prevent="subjectList(subject.id, subject.name)"
    >
      <button :class="childClassList" tabindex="0">
        {{ subject.name }}
      </button>
    </div>

    <infinite-loading
      :identifier="infiniteId"
      spinner="spiral"
      @infinite="fetchData"
    >
      <div slot="no-more" class="mgt-16 d-none"></div>
      <div slot="no-results" class="mgt-16 d-none"></div>
    </infinite-loading>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { mapActions } from "vuex";

import mainApi from "@/api/mainApi";

export default {
  name: "CategoryListComponent",
  components: {
    InfiniteLoading,
  },
  props: [
    "type",
    "isIdpService",
    "categoryList",
    "parentClassList",
    "childClassList",
    "categoryTotalPage",
    "isSkillPath",
  ],

  data() {
    return {
      currentPage: 2,
      totalPages: this.categoryTotalPage,
      infiniteId: +new Date(),
      listData: this.categoryList,
    };
  },

  methods: {
    ...mapActions("nav", ["SET_IS_OPEN_CATEGORY"]),

    // 목록 데이터 로딩(get list data)
    async fetchData($state) {
      const params = this.setParams();
      if (this.totalPages >= this.currentPage) {
        try {
          const requestApi = this.isSkillPath
            ? mainApi.fetchMicroSubject(params)
            : mainApi.fetchSubject(params);
          const result = await requestApi;
          console.log(result);
          let responseData = result.data.data;
          this.listData = this.listData.concat(
            responseData.content.filter((val) => val.desktopMain)
          );
          this.currentPage++;
          $state[responseData.content.length ? "loaded" : "complete"]();
          this.isNoData = !this.listData.length;
        } catch (error) {
          $state.error();
          console.log(error);
        }
      } else {
        $state.complete();
      }
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        page: this.currentPage,
        size: 20,
      };
      return params;
    },

    subjectList(id, name) {
      this.SET_IS_OPEN_CATEGORY(false);
      this.$router
        .push({
          name: "Subject",
          params: { id },
          query: {
            title: name,
            status: "LEARNING",
            type: this.isSkillPath ? "MICRO" : "",
          },
        })
        .catch((err) => {
          console.log("SUBJECT LIST ERROR : ", err);
        });
    },
  },
};
</script>

<style scoped>
.category-item {
  box-sizing: border-box;
  width: 100%;
  min-height: 48px;
  height: auto;
  color: var(--BodygrayA);
  display: flex;
  padding: 16px;
  font-weight: 300;
}
.category-item:hover {
  background-color: var(--BlackHover);
  font-weight: bold;
}
.category-item:hover button {
  font-weight: bold;
  color: var(--HeadlineBlack) !important;
}
.category {
  height: 48px;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: var(--BodygrayA);
  justify-content: space-between;
  font-weight: 400;
  cursor: pointer;
  position: relative;
}
.category:hover {
  font-weight: 900;
  color: var(--HeadlineBlack);
  background-color: var(--BlackHover);
}
</style>